import { createGuidFromInput } from '@coin-siemens-energy/deterministic-id-factory';

export class EmployeeHelper {
  public static getEmployeeIdByGid(gid: string): string {
    return createGuidFromInput(gid.toUpperCase());
  }
}
